import { render, staticRenderFns } from "./FastbotTV.vue?vue&type=template&id=0f55274f&scoped=true"
import script from "./FastbotTV.vue?vue&type=script&lang=ts"
export * from "./FastbotTV.vue?vue&type=script&lang=ts"
import style0 from "./FastbotTV.vue?vue&type=style&index=0&id=0f55274f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f55274f",
  null
  
)

export default component.exports